import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Carousel from 'react-material-ui-carousel';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { saveAgreementInfo } from '../../../../../../redux/agreement/actions';
import styles from './OptionContent.module.scss';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const OptionContent = ({
	saveAgreementInfo,
	optionCheck,
	setOptionCheck,
	setTotalOptionPrice,
	items,
	lotSelected,
}) => {
	const params = useParams();

	const [openImage, setOpenImage] = useState(false);
	const [photoIndex, setPhotoIndex] = useState(0);
	const [hover, setHover] = useState();

	const useStyles = makeStyles((theme) => ({}));

	const classes = useStyles();

	console.log('items', items);

	useEffect(() => {
		var optionCheckKeys = optionCheck && Object.keys(optionCheck);
		if (optionCheckKeys && optionCheckKeys.length > 0) {
			var priceArr = [];

			optionCheckKeys.forEach((key) => {
				if (optionCheck[key]) {
					var price = parseInt(optionCheck[key]['value']);

					priceArr.push(price);
				}
			});

			setTotalOptionPrice(priceArr?.reduce((a, b) => a + b, 0));
		} else {
			setTotalOptionPrice(0);
		}
	}, [optionCheck]);

	const handleOptionsCheck = (e) => {
		//not actually floor plans but options now
		if (
			optionCheck[e.target.id] !== null &&
			optionCheck[e.target.id] !== undefined
		) {
			if (e.target.checked === false) delete optionCheck[e.target.id];
			setOptionCheck({
				...optionCheck,
			});
		} else {
			setOptionCheck({
				...optionCheck,
				[e.target.id]:
					e.target.checked === true
						? { name: e.target.name, value: e.target.value }
						: 0,
			});
		}
	};

	const chunk = (arr, chunkSize) => {
		const res = [];
		for (let i = 0; i < arr?.length; i += chunkSize) {
			const chunk = arr.slice(i, i + chunkSize);
			res.push(chunk);
		}
		return res;
	};

	const newArray = chunk(items, 2).reduce((acc, item) => {
		return [...acc, { items: item.map((i) => ({ option: i })) }];
	}, []);

	console.log('newArray', newArray);

	return (
		<div className={styles.optionContentWrapper}>
			<div className={styles.title}>Select Options</div>
			<div className={styles.content}>
				<Carousel
					autoPlay={false}
					className={styles.carousel}
					navButtonsAlwaysInvisible={
						newArray.length > 0 ? true : false
					}
					navButtonsProps={{
						style: {
							backgroundColor: 'var(--primary)',
						},
						className: 'navigation',
						'aria-label': 'button-wrapper',
					}}
					fullHeightHover
					navButtonsWrapperProps={{
						className: 'navButtonWrapper',
					}}
					activeIndicatorIconButtonProps={{
						style: {
							color: 'var(--primary-hover)',
						},
					}}
					indicatorIconButtonProps={{
						style: {
							color: 'var(--primary-label)',
						},
						'aria-label': 'indicator-icon',
					}}
				>
					{newArray?.map((item, arrayIndex) =>
						item.items.map((item, index) => {
							console.log('sfwsf', item);
							console.log(
								'arrayIndex',
								optionCheck['' + index + arrayIndex]
							);
							console.log(
								'This sit the a',
								item?.option?.ignoreLot
							);
							var ignoreLotArr = item?.option?.ignoreLot;
							var disable = ignoreLotArr?.includes(lotSelected);
							return (
								<div
									className={styles.optionItem}
									onMouseEnter={() => setHover(index)}
									onMouseLeave={() => setHover()}
								>
									<FormControlLabel
										control={
											<Checkbox
												id={'' + index + arrayIndex}
												checked={
													optionCheck[
														'' + index + arrayIndex
													] ?? ''
												}
												onChange={(e) =>
													handleOptionsCheck(e)
												}
												value={item.option.price}
												name={item.option.name}
												// style={{
												// 	color: 'var(--primary)',
												// 	marginRight: '6px',
												// }}
												disabled={disable}
												inputProps={{
													className: clsx(
														classes.label
													),
												}}
												color='primary'
											/>
										}
										label={
											<Typography
												style={{
													color: '#000',
													fontSize:
														'var(--text-size-body)',
												}}
											>{`${item.option.name} - $${item.option.price}`}</Typography>
										}
										labelPlacement='right'
									/>
									<div
										className={styles.optionImage}
										onClick={() => setOpenImage(true)}
									>
										<img src={item.option.image} alt='' />
										{hover === index && (
											<div className={styles.layout}>
												<div
													className={styles.zoomIcon}
												>
													<ZoomInIcon />
												</div>
											</div>
										)}
									</div>
								</div>
							);
						})
					)}
				</Carousel>

				{openImage && (
					<Lightbox
						mainSrc={items[photoIndex].image}
						nextSrc={items[(photoIndex + 1) % items.length].image}
						prevSrc={
							items[
								(photoIndex + items.length - 1) % items.length
							].image
						}
						onCloseRequest={() => setOpenImage(false)}
						onMovePrevRequest={() =>
							setPhotoIndex(
								(photoIndex + items.length - 1) % items.length
							)
						}
						onMoveNextRequest={() =>
							setPhotoIndex((photoIndex + 1) % items.length)
						}
					/>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	items: state.agreement.optionDetails,
	lotSelected:
		state.agreement.productAvailability.lotId ||
		state.agreement.agreementById.productAvailability.lotId,
});

export default connect(mapStateToProps, { saveAgreementInfo })(OptionContent);
